var app = angular.module("leonardo");

var PortfolioGroupListFilters = function(
  $scope,
  $controller
) {

  $controller('FiltersBaseController', {$scope: $scope});

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'managed_by_reports',
          name: 'Management Company',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Management Companies',
          condition: $scope.filterService.managers.length > 1,
          options: $scope.filterService.managers,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'search',
      name: 'Portfolio/Property name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Portfolio/Property name',
      condition: true,
      onSubmit: $scope.filter,
      conflicts: []
    },
    {
      id: 'levels',
      name: 'Address',
      label: null,
      inline: false,
      type: 'levels',
      condition: true,
      conflicts: []
    }
  ];

};

app.controller('PortfolioGroupListFilters', [
  '$scope',
  '$controller',
  PortfolioGroupListFilters
]);
